<template>
  <div class="guidance-link" data-test="guidance-button">
    <a :href="props.link" data-test="guidance-link">
      <img
        src="../assets/book-info-icon.svg"
        alt="guidance link"
        class="guidance-icon-img"
        data-test="guidance-image"
      />
    </a>
    <Tooltip
      v-if="props.tooltipText && !isMobileView"
      :text="props.tooltipText"
      :target="props.tooltipTarget"
      data-test="guidance-tooltip"
    />
  </div>
</template>

<script setup lang="ts">
import { Tooltip } from "uiv";
import { computed } from "vue";
import { isMobile } from "mobile-device-detect";

const props = defineProps<{
  link: string;
  tooltipText: string;
  imgWidth?: string;
  tooltipTarget: string;
}>();

const imageWidth = computed(() => {
  return props.imgWidth ?? "50px";
});

const isMobileView = computed(() => {
  return isMobile;
});
</script>

<style scoped lang="less">
@import (reference) "../styles/bootstrap/variables.less";

@border-colour: @btn-default-border;
@border-colour-hover: @brand-primary;

.guidance-link {
  width: v-bind(imageWidth);
  // min-height: 50px;
  border-radius: 100vmax;
  border: 1px solid @border-colour;

  &:hover {
    border-color: @border-colour-hover;
  }
}

.guidance-icon-img {
  max-width: 100%;
  padding: 1rem;
}
</style>
